module.exports = __webpack_public_path__ + "static/car_product_3-1774028952dac62f61dc70d175696b70.jpg";